import React, {useState} from "react";
import { makeStyles } from '@material-ui/core/styles';
import $ from 'jquery';


import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'


const useStyles = makeStyles((theme) => ({
    replyholder:{      
      marginLeft: 20,
      marginBottom: 5,
      paddingBottom:0
  },
  reply:{
      padding: 5,
      paddingLeft: 20,
      borderLeft: '2px solid lightblue',
      margin: 10,
  },
  input: {
    margin: theme.spacing(1),
    width: '100%',
  },
  authorinfo:{
    marginBottom: 5,
    display: 'flex'
}  
}));

export default function ReplyHolder(props){
    const username = localStorage.getItem('username');
    const replies = props.replies;
    const classes=useStyles();
    const [replyinput, setReplyInput]=useState('');
    const [validity, setValidity]=useState(false);

    const handleChange = (event) => {
        var textval=event.target.value;
        setReplyInput(textval);
        setValidity((textval.length>5));
    }

    const handleAddReply = () =>{
        props.addReply(username, props.commentId, replyinput);
        setReplyInput('');
        setValidity(false);
        $('#reply-input-'+props.commentId).val('');
    }

    const handleDeleteReply = (reply_id) =>{
        props.deleteReply(username, props.commentId, reply_id);
    }

    return(
        <div className={classes.replyholder}>
            <Container>
                {replies.map((reply, idx)=>{
                    return(
                        <Container className={classes.reply} key={reply.id}>
                        <Grid container   id={reply.id} style={{height: '24px'}}>
                            <Grid  item xs={11} style={{display: 'flex'}}>
                                <Typography variant="body2"  style={{lineHeight: '16px', fontWeight:'800'}}>
                                    {reply.author}
                                </Typography>
                            </Grid>
                            <Grid item xs={1}  style={{alignSelf: 'center'}}>
                                {reply.username===props.username?   
                                <Button variant="outlined" style={{display: "flex", border: 0, color: 'palevioletred', padding: '0px'}}  onClick={()=>handleDeleteReply(reply.id)}>
                                    <FontAwesomeIcon icon={faTrashAlt} size="xs"/> 
                                </Button>
                                : null
                                    }
                            </Grid>
                        </Grid>
                        <Grid  style={{textAlign: 'justify', paddingLeft: '4px', paddingRight: '16px'}}>
                            <Typography variant="body2" color="textPrimary" component="p" style={{ whiteSpace: 'pre-line'}}>
                                {reply.text}     
                            </Typography>
                        </Grid> 
                        </Container>
                    )
                })}
                <Container className={classes.reply}>
                    <Grid className={classes.authorinfo} style={{height: '24px'}}>
                        <Typography gutterBottom variant="body2" style={{lineHeight: '24px', fontWeight:'800'}}>
                            {props.displayname}
                        </Typography>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={10} style={{padding: 0}}>
                            <TextField
                            className={classes.input}
                            defaultValue=""
                            variant="outlined"
                            multiline
                            size="small"
                            onChange={handleChange}
                            id={"reply-input-"+ props.commentId}
                            />
                        </Grid>
                        <Grid item xs={2} style={{display: "flex", padding:0, paddingLeft: 5 }} >
                            <Button className={classes.input} variant="outlined" style={{display: "flex" }} disabled={!validity} onClick={handleAddReply}>
                              Add      
                            </Button>
                        </Grid>
                    </Grid>
                </Container>
            </Container>    
        </div>
    )
}
